<template>
  <v-container class="pa-7">
    <p class="title font-weight-bold">My Progress</p>
    <v-divider class="my-10"></v-divider>
    <v-row>
      <v-col cols="12" sm="10" md="6" xl="4">
        <v-card min-height="287" class="half-radius shadow py-6 px-7">
          <p class="mb-1 title font-weight-bold">Your Level</p>
          <p class="mb-7" style="font-size: 1.875rem">{{ level }}</p>
          <p class="mb-1 font-weight-bold title">Current Step:</p>
          <v-card min-height="80" class="shadow half-radius pink-card">
            <v-container>
              <v-row align="center" class="px-5">
                <v-col class="pa-0 white--text">
                  <span class="font-weight-bold">
                    {{ progress ? progress.lesson_name : "" }}
                  </span>
                  <p>Step: {{ stepName }}</p>
                </v-col>
                <v-btn
                  depressed
                  small
                  color="white"
                  class="mb-2 black--text font-weight-bold text-capitalize"
                  :loading="loadingResume"
                  @click="onResumeWork"
                  >Go To Step</v-btn
                >
              </v-row>
            </v-container>
          </v-card>
        </v-card>
      </v-col>
      <v-col cols="12" sm="5" md="4" lg="3" xl="2">
        <v-card
          min-height="287"
          color="#29284C"
          class="text-center half-radius py-6 px-7 white--text"
        >
          <p class="mb-0 title font-weight-bold">Lesson Progress</p>
          <span class="font-weight-semibold big pinker">{{ completed }}</span>
          <span class="big stick font-weight-light">/</span>
          <span class="medium">{{ total }}</span>
          <app-progress-bar
            :duration="total"
            :value="completed"
            height="17"
            :numbers="false"
            fillColor="#00EAFF"
            background="white"
          ></app-progress-bar>
        </v-card>
      </v-col>
    </v-row>
    <v-divider class="my-10"></v-divider>
  </v-container>
</template>
<script>
import ProgressBar from "./Lessons/Lesson/components/ProgressBar.vue";
import { getLessonProgress, getLevelById, getLessons } from "@/api/api";
import resumeProgressMixin from "../mixins/resumeProgressMixin";
import { stepTypes } from "./Lessons/Lesson/stepsDefinition";

export default {
  components: {
    appProgressBar: ProgressBar,
  },
  mixins: [resumeProgressMixin],
  data() {
    return {
      total: 0,
      completed: 0,
      level: "",
      steps: {
        intro_step: "Not Started",
        vocabulary_step: "Vocabulary",
        audio_text_step: "Listening",
        audio_transcript_step: "Pronunciation",
        grammar_step: "Grammar",
        speaking_step: "Speaking",
        conclusion_step: "Completed!",
      },
    };
  },
  computed: {
    stepName() {
      const stepDefinition = stepTypes.find((step) => step.value === this.progress.step_type);

      switch (stepDefinition.key) {
        case "TEACH_INTRO":
          return "Lesson introduction";
        case "GRAMMAR_EXERCISE":
          return "Sentence Structure - Exercise " + this.progress.step_number;
        default:
          switch (stepDefinition.section) {
            case "TEACHER_LESSON":
              return stepDefinition.key;
            case "PRACTICE":
              return "Lesson Practice - " + stepDefinition.key;
            default:
              return "";
          }
      }
    },
  },
  async mounted() {
    this.getProgress();
    const response = await getLevelById(this.$store.getters["modules/selectedModule"].level);
    this.level = response.data.name;

    response.data.modules.forEach(async (element) => {
      const lessons = await getLessons({
        module__uuid: element,
        ready: true,
      });
      this.total += lessons.data.count;
    });
    getLessonProgress({
      student__email: this.student.email,
      lesson__uuid: this.$store.getters["modules/currentLesson"].uuid,
      completed: true,
    }).then((response) => {
      this.completed = response.data.count;
    });
  },
};
</script>
<style scoped>
.pink-card {
  background: transparent linear-gradient(180deg, #ff2e7b 0%, #c71252 100%) 0% 0% no-repeat
    padding-box;
  font-size: 1.125rem;
}
.pinker {
  color: #ff347c;
}
.big {
  font-size: 9.125rem;
  line-height: 1.2;
}
.stick {
  letter-spacing: -1rem;
}
.medium {
  font-size: 3.6875rem;
}
</style>
